import angular from 'angular';

angular.module('vrm.components').controller('AttributeSearchController', AttributeSearchController);

/* @ngInject */
function AttributeSearchController($scope, close) {
    return {
        close,
    };
}
